import { SvgIcon, SvgIconProps } from '@mui/material'

const CloseSmall = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M6.47 6.47a.75.75 0 0 1 1.06 0l10 10a.75.75 0 1 1-1.06 1.06l-10-10a.75.75 0 0 1 0-1.06Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M17.53 6.47a.75.75 0 0 1 0 1.06l-10 10a.75.75 0 0 1-1.06-1.06l10-10a.75.75 0 0 1 1.06 0Z" />
    </SvgIcon>
  )
}

export default CloseSmall
